import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	TemplateRef,
	ViewChild,
} from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { Router } from "@angular/router";
import { Columns, Config, DefaultConfig } from "ngx-easy-table";
import { Candidate } from "src/app/models/models";
import { getRankLabel } from "src/app/shared/utils/rank-label.util";
import { RoleService } from "../../services/role.service";

@Component({
	selector: "app-cbta-students-table",
	templateUrl: "./cbta-students-table.component.html",
	styleUrls: ["./cbta-students-table.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaStudentsTableComponent implements OnInit {
	@Input() students: Candidate[] = [];

	public columns!: Columns[];
	public configuration!: Config;

	@Output() onSelect: EventEmitter<Candidate[]> = new EventEmitter<Candidate[]>();
	@Output() onDownload: EventEmitter<Candidate> = new EventEmitter<Candidate>();

	links: Candidate[] = [];
	// private STUDENT_STATUS = CONSTANT.STUDENT_STATUS;

	@ViewChild("imageTpl", { static: true }) imageTpl!: TemplateRef<any>;
	@ViewChild("nameTpl", { static: true }) nameTpl!: TemplateRef<any>;
	@ViewChild("rankTpl", { static: true }) rankTpl!: TemplateRef<any>;
	@ViewChild("idTpl", { static: true }) idTpl!: TemplateRef<any>;
	// @ViewChild('statusTpl', { static: true }) statusTpl!: TemplateRef<any>;
	@ViewChild("licenseNumberTpl", { static: true })
	licenseNumberTpl!: TemplateRef<any>;
	@ViewChild("statusTpl", { static: true }) statusTpl!: TemplateRef<any>;
	@ViewChild("actionTpl", { static: true }) actionTpl!: TemplateRef<any>;

	constructor(
		private router: Router,
		private roleService: RoleService,
	) {}

	// isCompleted( status: string ) : boolean {
	//   return status.toLowerCase() === this.STUDENT_STATUS.COMPLETED;
	// }

	// isPending( status: string ) : boolean {
	//   return status.toLowerCase() === this.STUDENT_STATUS.PENDING;
	// }

	ngOnInit(): void {
		this.configuration = { ...DefaultConfig };
		this.configuration.searchEnabled = false;
		this.configuration.tableLayout.style = "bigger";
		this.configuration.paginationEnabled = false;
		// paginationEnabled only hides the pager UI; rows still slices via | paginate.
		this.configuration.rows = Math.max(this.students?.length || 0, 1000);
		// Wide pilot columns need horizontal scroll on small screens.
		this.configuration.horizontalScroll = true;
		this.configuration.fixedColumnWidth = false;
		// Keep chronological order from TrainingDetailsComponent; do not re-sort on header click.
		this.configuration.orderEnabled = false;

		this.columns = [
			{
				key: "imgeUrl",
				title: "",
				cellTemplate: this.imageTpl,
				width: "5%",
			},
			{
				key: "name",
				title: "Pilot Name",
				cellTemplate: this.nameTpl,
				width: "20%",
			},
			{
				key: "rank",
				title: "Rank",
				cellTemplate: this.rankTpl,
				width: "15%",
			},
			{
				key: "id",
				title: "Staff No.",
				cellTemplate: this.idTpl,
				width: "15%",
			},
			{
				key: "licenseNumber",
				title: "License No.",
				cellTemplate: this.licenseNumberTpl,
				width: "12%",
			},
			{
				key: "status",
				title: "Status",
				cellTemplate: this.statusTpl,
				width: "18%",
			},
			{
				key: "",
				title: "Action",
				cellTemplate: this.actionTpl,
				cssClass: { name: "text-center", includeHeader: true },
				width: "15%",
			},
		];

		setTimeout(() => {
			this.links = this.students;
			this.onSelect.emit(this.students);
		});
	}

	getRank(rank?: string) {
		return getRankLabel(rank);
	}

	download(row: Candidate): void {
		this.onDownload.emit(row);
	}

	goTo(candidateId: string) {
		this.router.navigate(["report/summary/", candidateId]);
	}

	onCheck(event: MatCheckboxChange, row: Candidate) {
		if (event.checked) {
			const candidateExists = this.links.some((candidate) => candidate.candidateId === row.candidateId);

			if (!candidateExists) {
				this.links.push(row);
			}
		} else {
			this.links = this.links.filter((candidate) => candidate.candidateId !== row.candidateId);
		}

		this.onSelect.emit(this.links);
	}

	get rs() {
		return this.roleService;
	}

	isPendingCandidateSignOff(candidate: Candidate): boolean {
		if (candidate.isPendingCandidateSignOff != null) {
			return candidate.isPendingCandidateSignOff;
		}
		return candidate.userId === candidate.candidateId && !candidate.summaryFilename;
	}
}
